import { store } from 'store';
import {
  SET_DIAS,
  SET_PADRONES,
  SET_CLASIFICADORES_ECONOMICOS,
  SET_CONTENT_TYPES_PADRONES,
  SET_ESTADOS_GLOBALES,
  SET_CATALOGOS_DE_REDONDEO,
  SET_ESTADOS_DEL_PADRON,
  SET_REGIMEN_DE_CAPITAL,
  SET_CATALOGO_DE_EFECTIVO,
  SET_CLASES_DE_VENCIMIENTO,
  SET_ESTADOS,
  SET_MESES,
  SET_CATALOGO_ERRORES_WS,
} from 'store/reducers/catalogs';
import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import getAllPages from 'utils/getAllPages';
import { onError } from 'utils/handlers';
import { padronesEnum } from 'views/Tramites/GPM/enums';

const baseURI = 'catalogos/';

const labelsPadrones = Object.freeze({
  [padronesEnum.VEHICULO]: 'Vehículo',
  [padronesEnum.JUEGO_DE_AZAR]: 'Juegos de Azar',
  [padronesEnum.CASA_DE_EMPENIO]: 'Casa de Empeño',
  [padronesEnum.POLICIA_ESPECIAL]: 'Policia Especial',
  [padronesEnum.INFRACCIONES]: 'Infracciones',
  [padronesEnum.COMERCIO_INFORMAL]: 'Comercio en Vía Pública',
  [padronesEnum.MERCADO]: 'Mercado',
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: 'Licencia de Funcionamiento',
  [padronesEnum.ZONA_EXCLUSIVA]: 'Zonas Exclusivas',
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: 'Anuncios',
  [padronesEnum.VENDEDOR_DE_ALCOHOLES]: 'Vendedor de Alcoholes',
  [padronesEnum.NOMINA]: 'Nómina',
  [padronesEnum.RETENEDOR_DE_NOMINA]: 'Retenedor de Nómina',
  [padronesEnum.LOTES_DE_PANTEON]: 'Lotes de Panteón',
  [padronesEnum.MODULOS]: 'Módulos',
});

/**
 * GET Content Types Padrones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContentTypesPadrones = async (params = null) => {
  try {
    const { contentTypesPadrones } = store.getState().catalogs;
    if (!contentTypesPadrones?.length) {
      const response = await API.get(`${baseURI}content-types-padrones`, { params });
      store.dispatch({
        type: SET_CONTENT_TYPES_PADRONES,
        payload: response.data,
      });
      return response.data;
    }
    return contentTypesPadrones;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Content Types Padrones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContentTypesPadronesPublic = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}content-types-padrones-public`, { params });
    store.dispatch({
      type: SET_CONTENT_TYPES_PADRONES,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Content Types Urs
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContentTypesURs = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}content-types-urs/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catálogos del Mes
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCatalogoDelMes = async (params = null) => {
  try {
    const _store = store.getState().catalogs;
    if (!_store?.meses?.length) {
      const response = await API.get(`${baseURI}catalogos-del-mes/`, { params });
      store.dispatch({
        type: SET_MESES,
        payload: response.data,
      });
      return response.data;
    }
    return _store.meses;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Regimen Capital
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRegimenCapital = async (params = null) => {
  try {
    const { regimenDeCapital } = store.getState().catalogs;
    if (!regimenDeCapital?.length) {
      const response = await API.get(`${baseURI}regimenes-capitales/`, { params });
      store.dispatch({
        type: SET_REGIMEN_DE_CAPITAL,
        payload: response.data,
      });
      return response.data;
    }
    return regimenDeCapital;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Rubros
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRubros = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}rubros/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clasificadores Economicos
 * @returns {Promise<object[]>}
 */
export const getClasificadoresEconomicos = async () => {
  try {
    const { clasificadoresEconomicos } = store.getState().catalogs;
    if (!clasificadoresEconomicos?.length) {
      const response = await API.get('catalogos/clasificadores-economicos/');
      store.dispatch({
        type: SET_CLASIFICADORES_ECONOMICOS,
        payload: response.data,
      });
      return response.data;
    }
    return clasificadoresEconomicos;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de paises
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCatalogoDePaises = async (params = null) => {
  try {
    const { paises } = store.getState().catalogs;
    if (paises.length) return { results: paises };
    const response = await API.get(`${baseURI}catalogos-de-paises/`, { params });
    if (response.data?.count) {
      return response.data;
    }
  } catch (err) {
    onError(err);
  }
  return { results: [] };
};

/**
 * GET Tipos de Combustibles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeCombustibles = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}tipos-de-combustibles-vehiculares/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Tramites Vehiculares
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeTramitesVehiculares = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}tipos-de-tramites-vehiculares/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

const onClickTitle = (e) => {
  const element = e.target;
  if (element) {
    let parent = element.parentElement;
    parent = parent ? parent.parentElement : null;
    if (parent) {
      const clickableSpan = parent.previousSibling;
      if (clickableSpan) {
        clickableSpan.click();
      }
    }
  }
};

const renderTitle = (title, bold) => (
  // eslint-disable-next-line
  <span onClick={onClickTitle} className={bold ? 'bold' : ''}>
    {title}
  </span>
);

/**
 * Formatea datos anidados para su uso en Tablas o TreeSelects
 * @param {Array<object} _data Estructura de datos anidada
 * @param {string} childrenProp Propiedad por medio de la cual se encuentran anidados los datos
 * @param {Array<string>} titleProps Propiedades a mostrar *Solo si se usara en TreeSelect
 * @returns {object[]}
 */
const normalizeData = (
  _data = [],
  childrenProp = 'children',
  titleProps = null,
  lastChildrensKey = 'id',
) => _data.map((_item) => {
  const item = { ..._item };
  const children = normalizeData(item[childrenProp], childrenProp, titleProps, lastChildrensKey);
  if (titleProps) {
    item.title = renderTitle(titleProps.map((p) => item[p]).join(' - '));
    item.selectable = !children.length;
    item.value = children.length ? item.clave : item[lastChildrensKey];
  } else {
    item.key = children.length ? item.id.toString().concat('_') : item.id;
  }
  if (children.length) {
    delete item[childrenProp];
    item.children = children;
  }
  return item;
});

/**
 * GET Clasificaciones Funcionales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getClasificacionesFuncionales = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}clasificaciones-funcionales/`, { params });
    return normalizeData(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTipos = async (params = null, forTree = true) => {
  try {
    const response = await API.get(`${baseURI}tipos/`, { params });
    const normalized = forTree
      ? normalizeData(response.data, 'tipos', ['clave', 'denominacion'], 'clave')
      : normalizeData(response.data, 'tipos');
    return normalized;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos
 * @param {object[]} tiposAnidados
 * @returns {object[]}
 */
export const extractorTipos = (tiposAnidados = []) => tiposAnidados
  .reduce((acc, curr) => acc.concat(curr.children), []);
/**

 *
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getUsosDeCFDI = async (params = null) => {
  try {
    const response = await API.get('catalogos/uso-del-cfdi/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Marcas de Remolques
 * @returns {Promise<Array<object>>}
 */
export const getMarcasDeRemolques = async (params = null) => {
  try {
    const response = await API.get('/catalogos/marca-de-remolques/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Usos de Remolques
 * @param {Array<object>}
 * @returns {Array<object>}
 */
export const getUsosDeRemolques = async (params = null) => {
  try {
    const response = await API.get('/catalogos/usos-de-remolques/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Documentos para Remolques
 * @param {Array<object>}
 * @returns {Array<object>}
 */
export const getDocumentosParaRemolques = async (params = null) => {
  try {
    const response = await API.get('/catalogos/tramite-de-remolques/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Marcas de Motocicletas
 * @returns {Promise<object[]>}
 */
export const getMarcasDeMotocicletas = async (params = null) => {
  try {
    const response = await API.get('/catalogos/marcas-de-motocicletas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Usos de Motocicletas
 * @param {object[]}
 * @returns {object[]}
 */
export const getUsoDeMotocicleta = async (id) => {
  try {
    const response = await API.get(`catalogos/usos-de-motocicletas/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Usos de Motocicletas
 * @param {object[]}
 * @returns {object[]}
 */
export const getUsosDeMotocicletas = async (params = null) => {
  try {
    const response = await API.get('catalogos/usos-de-motocicletas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Documentos para Motocicletas
 * @param {object[]}
 * @returns {object[]}
 */
export const getDocumentosParaMotocicletas = async (params = null) => {
  try {
    const response = await API.get('catalogos/documentos-para-motocicletas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Dias
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getDias = async (params = null) => {
  try {
    if (!store.getState()?.catalogs?.dias?.length) {
      const response = await API.get(`${baseURI}catalogos-de-dias/`, { params });
      store.dispatch({
        type: SET_DIAS,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.dias;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dias
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeSuelo = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}tipos-de-suelos/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTipoDePadronPorContenType = (contentTypeId) => {
  const contentType = store.getState()
    .catalogs.contentTypesPadrones.find((p) => p.id === contentTypeId);
  return store
    .getState().catalogs.padrones.find((p) => p.id === contentType?.nivel)?.id;
};

export const getContenTypePorTipoDePadron = (tipoDePadronId) => store
  .getState().catalogs.contentTypesPadrones.find((p) => p.nivel === tipoDePadronId)?.id;

const catalogoDePadronesMapper = (padron, contentTypes) => {
  const descripcion = labelsPadrones?.[padron.id] || padron.descripcion;
  const content_type = contentTypes.find((ct) => ct.nivel === padron.id)?.id;
  return { ...padron, descripcion, content_type };
};
/**
 * GET Padrones
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getCatalogoDePadrones = async (params = null, config) => {
  try {
    const { padrones } = store.getState().catalogs;
    const contentTypes = await getContentTypesPadrones();
    if (!padrones?.length) {
      const response = await API.get(`${baseURI}padrones/`, { params, ...config });
      const payload = response.data.map((e) => catalogoDePadronesMapper(e, contentTypes));
      store.dispatch({
        type: SET_PADRONES,
        payload,
      });
      return payload;
    }
    return padrones;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Padrones
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getCatalogoDePadronesPublic = async (params = null, config) => {
  try {
    const contentTypes = await getContentTypesPadronesPublic();
    const response = await API.get(`${baseURI}padrones/`, { params, ...config });
    const payload = response.data.map((e) => catalogoDePadronesMapper(e, contentTypes));
    store.dispatch({
      type: SET_PADRONES,
      payload,
    });
    return payload;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Codigos Postales por ID
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export const getCodigoPostalById = async (id) => {
  try {
    const response = await API.get(`${baseURI}codigos-postales/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return {};
  }
};

/**
 * GET Estados
 * @returns {Promise <object[]>}
 */
export const getEstados = async () => {
  try {
    const { estados } = store.getState().catalogs;
    if (estados?.length) return estados;
    const response = await API.get('catalogos/estados/');
    store.dispatch({
      type: SET_ESTADOS,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Municipios
 * @param {Object} params
 * @returns {Promise <object[]>}
 */
export const getMunicipios = async (params = null) => {
  try {
    const response = await API.get('catalogos/municipios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Codigos postales
 * @param {Object} params
 * @returns {Promise <object[]>}
 */
export const getCodigosPostales = async (params = null, all = false) => {
  try {
    const response = await API.get('catalogos/codigos-postales/', { params });
    if (all) {
      if (!response.data.next) return response.data.results;
      const page = new URL(response.data.next).searchParams.get('page');
      const _codigosPostales = await getCodigosPostales({ ...params, page }, all);
      return response.data.results.concat(_codigosPostales);
    }
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Catalogo de efectivo
 * @returns {Promise<object[]>}
 */
export const getCatalogoDeEfectivo = async () => {
  try {
    const { catalogoDeEfectivo } = store.getState().catalogs;
    if (!catalogoDeEfectivo?.length) {
      const response = await API.get('/catalogos/catalogos-de-efectivo/');
      store.dispatch({
        type: SET_CATALOGO_DE_EFECTIVO,
        payload: response.data,
      });
      return response.data;
    }
    return catalogoDeEfectivo;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de Folio de Recibo
 * @returns {Promise<object[]>}
 */
export const getCatalogoFolioRecibo = async () => {
  try {
    const response = await API.get('catalogos/catalogo-de-folio-de-recibo');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Marcas Vehiculares
 * @param {Object} params
 * @returns {Promise <Object>}
 */
export const getMarcasVehiculares = async (params = null) => {
  try {
    const response = await API.get('recaudacion/marcas-de-vehiculos/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 *  GET Documentos de Regularización
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosDeRegularizacion = async (params = null) => {
  try {
    const response = await API.get('/catalogos/clave-de-documento-de-regularizacion/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET versiones vehiculares
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getVersionesVehiculares = async (params = null) => {
  try {
    const response = await API.get('/catalogos/versiones-vehiculares/', { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};
export const getTiposDeVistasCuentaUnica = async () => {
  try {
    const response = await API.get('/catalogos/tipos-de-vistas-cuenta-unica/');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
export const getTiposDeAfectacion = async () => {
  try {
    const response = await API.get('/catalogos/tipos-de-afectacion/');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Ordenamientos
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeOrdenamientos = async (params = null) => {
  try {
    const response = await API.get('/catalogos/tipo-de-ordenamiento/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Ordenamientos
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getAmbitosDeOrdenamientos = async (params = null) => {
  try {
    const response = await API.get('/catalogos/ambito-de-ordenamiento/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Razones de Rechazo
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getRazonesDeRechazo = async (params = null) => {
  try {
    const response = await API.get('/catalogos/razones-de-rechazo/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/*
 * GET Estados de los padrones
 * @return {Promise<Array<object>>}
 */
export const getEstadosDelPadron = async () => {
  try {
    const { estadosDelPadron } = store.getState().catalogs;
    if (!estadosDelPadron?.length) {
      const response = await API.get('/catalogos/estados-del-padron/');
      store.dispatch({
        type: SET_ESTADOS_DEL_PADRON,
        payload: response.data,
      });
      return response.data;
    }
    return estadosDelPadron;
  } catch (error) {
    onError(error);
    return [];
  }
};

/*
 * GET Estados Globales
 * @return {Promise<object[]>}
 */
export const getEstadosGlobales = async (config) => {
  try {
    const response = await API.get('/catalogos/estados-globales/', config);
    store.dispatch({
      type: SET_ESTADOS_GLOBALES,
      payload: response.data,
    });
    return response.data;
  } catch {
    return [];
  }
};
/*
 * GET Estados Globales
 * @return {Promise<object[]>}
 */
export const getCatalogosDeRedondeo = async () => {
  try {
    const response = await API.get('/catalogos/catalogos-de-redondeo/');
    store.dispatch({
      type: SET_CATALOGOS_DE_REDONDEO,
      payload: response.data,
    });
    return response.data;
  } catch {
    return [];
  }
};

/*
 * GET Multiples Catalogos
 */
export const getCatalogos = async (promises) => {
  await Promise.all(promises.map((promise) => promise()));
};

/**
 * GET Tipos de Zonas Exclusivas
 * @returns {Promise<object[]>}
 */
export const getTiposDeZona = async () => {
  try {
    const response = await API.get('/catalogos/tipos-de-zonas-exclusivas/');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET catalogo de padrones a publico
 * @returns {Promise<object[]>}
 */
export const getPadronCatalogoPublico = async () => {
  try {
    const response = await API.get(`${baseURI}/content-types-padrones-public`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET catalogo de padrones a publico
 * @returns {Promise<object[]>}
 */
export const getMotivosMeritoDemerito = async () => {
  try {
    const response = await API.get(`${baseURI}/motivos-de-merito-demerito-terreno`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Procedencias de vehiculos
 * @returns {Promise<object|null>}
 */
export const getProcedenciaDeVehiculo = async (id) => {
  try {
    const response = await API.get(`recaudacion/procedencia-del-vehiculo/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Procedencias de vehiculos
 * @returns {Promise<object[]>}
 */
export const getProcedenciasDeVehiculos = async () => {
  try {
    const response = await API.get('recaudacion/procedencia-del-vehiculo');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET clases de vencimiento de parcialidades
 * @returns {Promise<object[]>}
 */
export const getClasesDeVencimientoDeParcialidades = async () => {
  try {
    const { clasesDeVencimiento } = store.getState().catalogs;
    if (clasesDeVencimiento?.length) return clasesDeVencimiento;
    const response = await API.get('catalogos/clases-de-vencimiento-de-parcialidades/');
    store.dispatch({
      type: SET_CLASES_DE_VENCIMIENTO,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getRoles = async () => {
  try {
    const response = await API.get('catalogos/roles/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getEstatusDePlacas = async () => {
  try {
    const response = await API.get('catalogos/estados-de-placas-vehiculares/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getCatalogoDeUsosDeConfiguracionesDePadrones = async (params) => {
  try {
    const response = await API.get('configuracion/catalogos-usos-de-configuraciones-de-padrones/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getPaginaCatalogoDeErroresWS = async (params) => {
  try {
    const { catalogoErroresWS } = store.getState().catalogs;
    if (catalogoErroresWS?.length) return catalogoErroresWS;
    const response = await API.get('catalogos/catalogo-de-errores-ws/', { params });
    store.dispatch({
      type: SET_CATALOGO_ERRORES_WS,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getCatalogoDeErroresWS = async (params) => {
  try {
    const { catalogoErroresWS } = store.getState().catalogs;
    if (catalogoErroresWS?.length) return catalogoErroresWS;
    const data = await getAllPages(getPaginaCatalogoDeErroresWS, params);
    store.dispatch({
      type: SET_CATALOGO_ERRORES_WS,
      payload: data,
    });
    return data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeDocumentosDeTraslaciones = async (params) => {
  try {
    const response = await API.get('catalogos/tipos-de-documentos-de-tanslaciones/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeAreasComunes = async (params) => {
  try {
    const response = await API.get('catalogos/tipos-de-areas-comunes/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
